<template>
  <div>
    <Title :pages="[{ icon: 'scale-balanced', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="d-flex align-start">
        <div style="flex: 0 0 auto">
          <Modal
            v-if="create_access"
            :button_name="$t('Crear') + ' ' + modal_title"
            :modal_title="modal_title"
            :formBtn="formBtn"
            :dialog="dialog"
            :parent="parent"
            :service="service"
            :emitters="emitters"
            @updateDialog="updateDialog"
            @loadList="filterList"
            :item="mainItem"
            @updateItem="
              (newItem) => {
                mainItem = newItem;
              }
            "
          />
        </div>

        <v-btn v-if="create_access" class="ml-3 mb-5 text-white" color="blue-grey" :disabled="emitter_selected == null" @click="dialog_bulk = true">Importar Cuentas</v-btn>
      </div>

      <ModalBulk v-if="create_access" modal_title="Carga masiva de cuentas" :dialog="dialog_bulk" :emitter="emitter_selected" @close="dialog_bulk = false" @filter="filterList" />

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-4 pt-0">
                  <v-radio-group v-model="selected_status" row class="mt-0 mb-0">
                    <v-radio label="Habilitado" :value="true"></v-radio>
                    <v-radio label="No habilitado" :value="false"></v-radio>
                    <v-radio label="Todos" value="all"></v-radio>
                  </v-radio-group>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="grupo_selected" autocomplete="off" item-text="name" item-value="id" :items="grupos" label="Grupo" class="pt-0 mt-0" clearable return-object></v-combobox>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-2" dark :disabled="emitter_selected == null" :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" @click="filterList">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <div class="px-4 pt-2">
            <v-btn outlined small color="blue-grey" @click="toggleAll">
              <v-icon left small>{{ allExpanded ? "unfold_less" : "unfold_more" }}</v-icon>
              {{ allExpanded ? "Colapsar todo" : "Expandir todo" }}
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <v-simple-table fixed-header height="65vh">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Código / Nombre</th>
                <th class="text-left">Grupo</th>
                <th class="text-left">Imputable</th>
                <th class="text-left">Habilitado</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="5" class="pa-0">
                  <v-progress-linear indeterminate color="primary" height="2"></v-progress-linear>
                  <div class="text-center py-6 grey--text">Cargando...</div>
                </td>
              </tr>
              <tr v-else-if="visibleRows.length === 0">
                <td colspan="5">
                  <v-alert :value="true" color="error" icon="warning" class="ma-2">
                    {{ "Busqueda sin resultados - " + search }}
                  </v-alert>
                </td>
              </tr>
              <tr v-for="row in visibleRows" :key="row.item.id" class="account-row">
                <td :style="{ paddingLeft: 16 + row.depth * 24 + 'px' }" style="white-space: nowrap">
                  <v-icon v-if="row.hasChildren" small class="mr-1 toggle-icon" @click="toggleExpand(row.item.id)">
                    {{ row.expanded ? "expand_more" : "chevron_right" }}
                  </v-icon>
                  <v-icon v-else small class="mr-1" color="grey lighten-1">remove</v-icon>
                  <span class="mr-2 grey--text text--darken-1">{{ row.item.code }}</span>
                  <span :class="{ 'font-weight-bold': !row.item.imputable }">{{ row.item.name }}</span>
                </td>
                <td>{{ row.item.grupo ? row.item.grupo.name : "-" }}</td>
                <td>
                  <v-chip x-small label :color="row.item.imputable ? 'light-blue lighten-4' : 'grey lighten-3'" :text-color="row.item.imputable ? 'light-blue darken-3' : 'grey darken-1'">
                    {{ row.item.imputable ? "SI" : "NO" }}
                  </v-chip>
                </td>
                <td>
                  <v-chip x-small label :color="row.item.enabled ? 'green lighten-4' : 'red lighten-4'" :text-color="row.item.enabled ? 'green darken-2' : 'red darken-2'">
                    <v-icon x-small left :color="row.item.enabled ? 'green' : 'red'">fiber_manual_record</v-icon>
                    {{ row.item.enabled ? "SI" : "NO" }}
                  </v-chip>
                </td>
                <td class="text-center px-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(row.item)">edit</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(row.item)">remove_red_eye</v-icon>
                    </template>
                    <span>Ver</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(row.item)">delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import ModalBulk from "./ModalBulk.vue";

export default {
  components: { Title, Modal, ModalBulk, DialogDelete },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      parent: this,
      service: generalService,
      page_title: "Plan de Cuentas",
      modal_title: "Cuenta",
      emitters: [],
      emitter_selected: null,
      grupo_selected: null,
      selected_status: true,
      grupos: [
        { id: 1, name: "Activo" },
        { id: 2, name: "Pasivo" },
        { id: 3, name: "Patrimonio Neto" },
        { id: 4, name: "Ingresos" },
        { id: 5, name: "Egresos" },
      ],
      mainItem: {
        id: "",
        code: "",
        name: "",
        grupo: null,
        parent: null,
        emitter: null,
        imputable: true,
        enabled: true,
      },
      defaultItem: null,
      list: [],
      loading: true, // evita el flash de "sin resultados" antes de la primera carga
      dialog_delete: false,
      dialog_bulk: false,
      // Ids de cuentas actualmente expandidas (solo aplica cuando no hay búsqueda activa)
      expandedIds: new Set(),
    };
  },
  computed: {
    // Agrupa las cuentas por parent_id (null = raíz), ordenadas por código.
    // Si el padre no vino en la lista (ej. filtro "No habilitado" con padre habilitado),
    // la cuenta se muestra como raíz: si no, el árbol nunca llega a ella.
    childrenByParent() {
      const map = {};
      const ids = new Set(this.list.map((a) => a.id));
      this.list.forEach((a) => {
        const key = a.parent && ids.has(a.parent.id) ? a.parent.id : "root";
        if (!map[key]) map[key] = [];
        map[key].push(a);
      });
      Object.values(map).forEach((arr) => arr.sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true })));
      return map;
    },
    rootAccounts() {
      return this.childrenByParent.root || [];
    },
    // Con búsqueda activa: true si la cuenta o algún descendiente matchea el término
    matchMap() {
      const term = (this.search || "").toLowerCase().trim();
      const map = {};
      if (!term) return map;
      const compute = (node) => {
        const children = this.childrenByParent[node.id] || [];
        let childMatch = false;
        children.forEach((c) => {
          if (compute(c)) childMatch = true;
        });
        const selfMatch = node.code.toLowerCase().includes(term) || node.name.toLowerCase().includes(term);
        const result = selfMatch || childMatch;
        map[node.id] = result;
        return result;
      };
      this.rootAccounts.forEach(compute);
      return map;
    },
    allExpanded() {
      const parents = this.list.filter((a) => (this.childrenByParent[a.id] || []).length > 0);
      return parents.length > 0 && parents.every((a) => this.expandedIds.has(a.id));
    },
    // Aplana el árbol respetando expandedIds; con búsqueda, expande automáticamente las ramas con match
    visibleRows() {
      const term = (this.search || "").toLowerCase().trim();
      const rows = [];
      const walk = (nodes, depth) => {
        nodes.forEach((node) => {
          if (term && !this.matchMap[node.id]) return;
          const children = this.childrenByParent[node.id] || [];
          const hasChildren = children.length > 0;
          const expanded = term ? true : this.expandedIds.has(node.id);
          rows.push({ item: node, depth, hasChildren, expanded });
          if (hasChildren && expanded) walk(children, depth + 1);
        });
      };
      walk(this.rootAccounts, 0);
      return rows;
    },
  },
  watch: {
    // Con "Todos", las deshabilitadas quedan anidadas bajo padres contraídos y no se
    // ven: se expanden las ramas que las contienen.
    list() {
      if (this.selected_status !== "all") return;
      const byId = {};
      this.list.forEach((a) => (byId[a.id] = a));
      const expanded = new Set();
      this.list
        .filter((a) => !a.enabled)
        .forEach((a) => {
          let parent = a.parent ? byId[a.parent.id] : null;
          while (parent && !expanded.has(parent.id)) {
            expanded.add(parent.id);
            parent = parent.parent ? byId[parent.parent.id] : null;
          }
        });
      this.expandedIds = expanded;
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.service.setSection(Constant.SECTION_ACCOUNTS);
    this.loadEmitters();
  },
  methods: {
    loadEmitters() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.filterList();
        } else {
          this.loading = false;
        }
      });
    },
    getFilterParams() {
      return {
        enabled: this.selected_status,
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        grupo: this.grupo_selected != null ? this.grupo_selected.id : null,
      };
    },
    filterList() {
      this.service.setSection(Constant.SECTION_ACCOUNTS);
      this.expandedIds = new Set();
      this.loadList(this.service, this.getFilterParams());
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_ACCOUNTS + "/list", param, "Plan-de-Cuentas.xlsx");
    },
    toggleExpand(id) {
      const next = new Set(this.expandedIds);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      this.expandedIds = next;
    },
    toggleAll() {
      if (this.allExpanded) {
        this.expandedIds = new Set();
      } else {
        const parents = this.list.filter((a) => (this.childrenByParent[a.id] || []).length > 0).map((a) => a.id);
        this.expandedIds = new Set(parents);
      }
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.filterList();
    },
  },
};
</script>

<style scoped>
.account-row td {
  height: 40px;
}
.toggle-icon {
  cursor: pointer;
}
</style>
